<script lang="ts" context="module">
  export type OptionsSelectorOption = {
    label: string;
    value: string;
  };
</script>

<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let options = [] as OptionsSelectorOption[];
  export let activeValue: string | undefined;
  export let active: OptionsSelectorOption = activeValue
    ? options.find((o) => o.value === activeValue) ?? options[0]
    : options[0];

  export function setActive(value: string) {
    const newActive = options.find((o) => o.value === value);
    if (newActive) {
      active = newActive;
      activeValue = value;
      dispatch('change', active);
    }
  }
</script>

<div
  role="tablist"
  aria-orientation="horizontal"
  data-orientation="horizontal"
  data-melt-tabs-list=""
  class="inline-flex h-10 items-center justify-center rounded-md bg-gray-100 p-1 text-muted-foreground"
>
  {#each options as option}
    {#if option === active}
      <button
        type="button"
        role="tab"
        data-state="active"
        tabindex="0"
        data-value="overview"
        data-orientation="horizontal"
        data-melt-tabs-trigger=""
        class="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-gradient-to-b from-black to-gray-900 px-3 py-1.5 text-sm font-medium text-white shadow-sm transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        >{option.label}</button
      >
    {:else}
      <button
        on:click={() => setActive(option.value)}
        type="button"
        role="tab"
        data-state="inactive"
        tabindex="-1"
        data-value="analytics"
        data-orientation="horizontal"
        data-disabled="true"
        data-melt-tabs-trigger=""
        class="inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm"
        >{option.label}</button
      >
    {/if}
  {/each}
</div>
